export const layoutEntryQueryKey = 'layout'
